import React from 'react';
import { Location, matchPath, useLocation, useNavigate, useParams } from 'react-router';
//import connect, { appendAuthorizationHeader } from '../utils/connector/api-connector';
import Calendar from '../model/Calendar';

import Agenda from '../components/Agenda';
import { nextCallBuilder, requestBuilder, titleFromParams } from '../utils/builders/date-builder';
import Error, { ErrorLevel } from '../components/Error/Error';
// import Spin from 'antd/lib/spin';
import Spinner from '../components/Spinner/Spinner';
// import { rootAPI } from '../constants/globals';
import PageHeader, { BreadcrumbItem } from '../components/Header/PageHeader';
import { useTranslation } from '@nic-react-i18n/core';
import { CalendarMode } from '../components/calendar/Moleskine';
import { useQuery } from '@tanstack/react-query';
import { AppConf } from '../AppConf';
import { useKeycloak } from '@nic-react/auth';
import { useAppendAuthorizationHeader } from '../utils/connector/api-connector';
import dayjs from 'dayjs';
import isoWeeksInYear from 'dayjs/plugin/isoWeeksInYear';
import isLeapYear from 'dayjs/plugin/isLeapYear';

dayjs.extend(isoWeeksInYear)
dayjs.extend(isLeapYear)
const CalendarController: React.FC<any> = (props) =>  {
    const {t} = useTranslation()
    const {keycloak} = useKeycloak()

    const header = useAppendAuthorizationHeader()
    const location = useLocation()
    const navigate = useNavigate()
    const params = useParams()

   // const period = params.period ?? 'week'
    //const year = params.year ?? moment().year()
    //const month = params.month ?? ''
    //const day = params.day

    //console.log('CalendarController: ', params)


    const selectHandler = (date: dayjs.Dayjs): void => {


        let next = nextCallBuilder(params, date);
        let path = requestBuilder(next);

        navigate(path);
    }

    const getParams = (location: Location<any>) => {
        let match =
            matchPath(
                {path: '/bookings/calendar/:period/:year?/:month?/:day?'},
                location.pathname
            );
        let res = (match !== undefined ?
                params :
                {period: 'week', year: dayjs().year(), month:  dayjs().isoWeeksInYear()}
        );
        return res;
    }

    const buildBreadcrumbList = () => {

        let _params = (params ?? getParams(location));

        let breadcrumbList: Array<BreadcrumbItem> = [];

        breadcrumbList.push({label: 'Home', pathname: '/home', hideIntl: true});

        let title = titleFromParams(_params, location, t);

        switch (params.period) {
            case 'year': {
                breadcrumbList.push({
                    // label: `${params.year}`,
                    label: `${title}`,
                    pathname: `/bookings/calendar/year/${params.year}`,
                    hideIntl: true
                });
                break;
            }
            case 'month': {
                /*
                breadcrumbList.
                    push({
                        label: `${intl.formatMessage({id: 'breadcrumb.year'})} ${params.year}`,
                        pathname: `/bookings/calendar/year/${params.year}`,
                        hideIntl: true
                    });
                    */
                breadcrumbList.push({
                    // label: `${intl.formatMessage({id: 'breadcrumb.month'})} ${params.month}`,
                    label: `${title}`,
                    pathname: `/bookings/calendar/month/${params.year}/${params.month}`,
                    hideIntl: true
                });
                break;
            }
            case 'week' : {
                /*
                breadcrumbList.
                    push({
                        label: `${intl.formatMessage({id: 'breadcrumb.year'})} ${params.year}`,
                        pathname: `/bookings/calendar/year/${params.year}`,
                        hideIntl: true
                    });
                    */
                breadcrumbList.push({
                    //  label: `${intl.formatMessage({id: 'breadcrumb.week'})} ${params.month}`,
                    label: `${title}`,
                    pathname: `/bookings/calendar/week/${params.year}/${params.month}`,
                    hideIntl: true
                });

                break;
            }
            case 'day': {
                /*
                breadcrumbList.
                    push({
                        label: `${intl.formatMessage({id: 'breadcrumb.year'})} ${params.year}`,
                        pathname: `/bookings/calendar/year/${params.year}`,
                        hideIntl: true
                    });
                breadcrumbList.
                    push({
                        label: `${intl.formatMessage({id: 'breadcrumb.month'})} ${params.month}`,
                        pathname: `/bookings/calendar/month/${params.year}/${params.month}`,
                        hideIntl: true
                    });
                    */
                breadcrumbList.push({
                    // label: `${intl.formatMessage({id: 'breadcrumb.day'})} ${params.day}`,
                    label: `${title}`,
                    pathname: `/bookings/calendar/day/${params.year}/${params.month}/${params.day}`,
                    hideIntl: true
                });
                break;
            }
            default: {
                let oggi = dayjs();
                breadcrumbList.push({
                    // label: `${intl.formatMessage({id: 'breadcrumb.calendar'})}`,
                    label: `${title}`,
                    pathname: `/bookings/calendar/year/${oggi.year()}`,
                    hideIntl: true
                });
                break;
            }

        }

        return breadcrumbList;
    }

    const getKeyFromPathname = (location: Location, queryString: URLSearchParams): string[] => {
        const res = location.pathname.split('/')
       // console.log('GetKeyFromPathname: ', res, location.pathname)

        Array.from(queryString.keys()).forEach((key: string) => {
            //console.log('SearchKey: ', key, queryString.get(key))
            res.push(`${key}:${queryString.get(key)}`)
        })

        return res
    }

    const {search} = location;
    const searchParams = new URLSearchParams(search)
  //  console.log('SIZE: ', searchParams.size)

    const queryString = searchParams.size > 0 ? `?${searchParams.toString()}`: ''


    const calendarData = useQuery({
        queryKey: [...getKeyFromPathname(location, searchParams)],
        queryFn: async () => {
            const {url:root} = AppConf.getRootUrl(keycloak.realm)
            const data =
                await fetch(
                    `${root}${location.pathname}${queryString}`, {...header})
            return data.json()
        }})



    const { calendar } = props;
    let component = <></>

    if (calendarData.isFetching) {
        component = <Spinner/>
    }
    if (calendarData.isError) {

        component  = (
            <Error
                level={ErrorLevel.ERROR}
                title={t('error.booking.title')}
                error={calendar.meta.response}
            />
        )
    }

    if (calendarData.isFetched) {
       // console.log('CalendarController Fetched: ', calendarData.data)

        let dayCalendar: Calendar = new Calendar(calendarData.data._embedded);
    //    console.log('CalendarController: dayCalendar ', dayCalendar)
        let value: dayjs.Dayjs = dayjs();

        if (params.period !== 'range') {

            // const stringDate = formatDateFromParams(params, );
            let date;

            const year = params.year !== undefined ? +(params.year) : 0
            const month = params.month ? +(params.month) : 0
            const day = params.day ? +(params.day) : 0
            switch (params.period) {
                case 'year': {
                    date = dayjs().year(year);
                    break;
                }
                case 'month': {
                    date = dayjs().year(year).month(month-1 );
                    break;
                }
                case 'week' : {
                    date = dayjs().year(year).isoWeek(month);
                    break;
                }
                case 'day': {
                    date = dayjs().year(year).month(month).day(day);
                    break;
                }
                default:
                    date = dayjs();
                    break;
            }

            value = date;

        }

        component = (
            <Agenda
                agenda={dayCalendar}
                value={value}
                mode={params.period as CalendarMode}
                selectHandler={selectHandler}
                requestCalendar={false}
            />
        );

    }


// console.log('CalendarController: ', this.props.match);
return (

    <PageHeader
        breadcrumb={
            buildBreadcrumbList()
        }
    >
        {component}
    </PageHeader>
);

}
export default CalendarController